import React, { FC, useState, useRef, useEffect } from 'react';
import { Slider } from 'components/RecommendSlider/components/Slider';
import { useAppDispatch } from '@doda/common/src/redux/hooks';
import { measureBookmarkRecommendCard } from 'pages/DodaFront/View/MatchJobList/logics/analytics';
import {
  measureRecommendVisible,
  measureClickRecommendCard,
} from '@doda/common/src/logics/JobContent/JobTrend/analytics';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { JobListResponse } from '@doda/api-client/aspida/@types';
import { useSelector } from 'react-redux';
import { useIntersection } from '@doda/common/src/hooks/useIntersection';
import { convertQuery } from '@doda/common/src/logics/JobContent/analytics';
import { JobRecommendCard } from '../JobRecommendCard';
import styles from './index.module.scss';

/**
 * JobRecommendのProps
 * @param jobList 取得した求人一覧
 * @param analyticsSelectedValue 計測用
 * @param selectedCount 選択された棒グラフの求人数
 */
interface Props {
  jobList: JobListResponse;
  analyticsSelectedValue: string;
  selectedCount: number;
}

export const JobRecommend: FC<Props> = ({
  jobList,
  analyticsSelectedValue,
  selectedCount,
}) => {
  const dispatch = useAppDispatch();
  const handleBookmark = (recommend) => {
    dispatch(measureBookmarkRecommendCard(recommend.jid));
  };

  // 計測用パラメータ値
  const queryParams = useSelector(appQueryParamsSelector);
  const analyticsValue = `${convertQuery(queryParams)}_${analyticsSelectedValue}`;

  // レコメンドvisible時計測用
  const ref = useRef<HTMLDivElement>(null);
  const { intersecting } = useIntersection(ref);
  const [visibled, setVisibled] = useState(false);
  useEffect(() => {
    if (intersecting && !visibled) {
      measureRecommendVisible(
        analyticsValue,
        jobList.results ? jobList.results : null
      );
      setVisibled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intersecting]);

  // レコメンドカードクリック時計測用
  const recommendType = `${analyticsValue}`;
  const effectName = `${recommendType}_pc`;
  const handleClickCard = () => {
    dispatch(
      measureClickRecommendCard({
        recommendType,
        effectName,
      })
    );
  };
  return (
    <div className={styles.jobRecommend} ref={ref}>
      {selectedCount !== 0 ? (
        <Slider>
          {jobList.results?.map((list, index) => (
            <JobRecommendCard
              key={index}
              companyName={list.corporateName}
              jobName={list.occupationName}
              area={list.jobState}
              income={list.salary}
              jobDetailUrl={`${list.url}?recommendID=ranking_${recommendType}`}
              isNew={false}
              isDeadline={false}
              onClickFavorite={() => {
                if (handleBookmark) handleBookmark(list);
              }}
              onClickSaved={undefined}
              onClickCardDetail={handleClickCard}
              bookmarkListUrl="/dcfront/bookmark/bookmarkList/"
              jid={list.jid}
              saveBookmarkRequestBody={{ device: 'PC' }}
              isBookmarked={list.isBookmarkSaved}
            />
          ))}
        </Slider>
      ) : (
        <div className={styles.jobRecommend__nothingJobs}>
          該当する求人はありません
        </div>
      )}
    </div>
  );
};
